//
// Module for Death Audit Providers Index view
//
rs.module("fund/configuration/deathauditproviders/index",

    [ /* dependencies */],

    function () {

        // Initialize the module
        function initialize(jsSelectors) {
            var providerForm = $.js(jsSelectors.providerForm);

            providerForm.js(jsSelectors.providerSelect).change(function () {
                this.form.submit();
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);